import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thumb'
})
export class ThumbPipe implements PipeTransform {

  transform(url: string, width: number = 300, quality: number = 80): string {
    if (!url) return '';
    
    // Verifica se é uma URL do seu CloudFront/S3 (ajuste o domínio conforme necessário)
    // Se for uma imagem externa (ex: facebook), não adiciona os parâmetros
    if (!url.includes('remateweb.com') && !url.includes('amazonaws.com') && !url.includes('cloudfront.net')) {
      return url;
    }

    // Se já tiver query params, usa & senão ?
    const separator = url.includes('?') ? '&' : '?';
    
    return `${url}${separator}w=${width}&q=${quality}&fmt=webp`;
  }

}
